export const CONSTANTS = {
    Enums: {
        LayoutKind: {
            ring: 'ring',
            sectorRing: 'sector-ring',
            spoke: 'spoke',
            crescent: 'crescent',
            concentricRing: 'concentric-ring',
        },
        ItemKind: {
            entity: 'entity',
            connector: 'connector',
        },
        ShapeKind: {
            sphere: 'sphere',
            panel: 'panel',
            ringGuide: 'ring-guide',
            lineGuide: 'line-guide',
            sectorSlice: 'sector-slice',
            annularBand: 'annular-band',
            cylinderWall: 'cylinder-wall',
            extrudedProfile: 'extruded-profile',
            revolvedProfile: 'revolved-profile',
        },
    },
};
